define.alias("shared/components/shared/table-analytics", "preview-grid/components/shared/table-analytics");